import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';

import { HomeComponent } from './home/home.component';

import { CustomersComponent } from './customers/customers.component';

import { EmployeeComponent } from './employee/employee.component';

import { LoginlayoutComponent } from './layouts/loginlayout/loginlayout.component';

import { MainlayoutComponent } from './layouts/mainlayout/mainlayout.component';

import { MeterdetailsComponent } from './meterdetails/meterdetails.component';

import { AreadetailsComponent } from './areadetails/areadetails.component';

import { UnitrateComponent } from './unitrate/unitrate.component';

import { BillreportsComponent } from './billreports/billreports.component';

import { ExpensesComponent } from './expenses/expenses.component';

import { ComplaintComponent } from './complaint/complaint.component';

import { AccessControlComponent } from './access-control/access-control.component';

import { WagesComponent } from './wages/wages.component';

import { WagedetailsComponent } from './wagedetails/wagedetails.component';

import { EmployeeLocationsComponent } from './employee-locations/employee-locations.component';

import { PayrollRunsComponent } from './payroll-runs/payroll-runs.component';

import { PayrollRunDetailsComponent } from './payroll-run-details/payroll-run-details.component';

import { PayrollProfilesComponent } from './payroll-profiles/payroll-profiles.component';

import { FuiDashboardComponent } from './fui-dashboard/fui-dashboard.component';
import { ComplaintsDashboardFuiComponent } from './complaints-dashboard-fui/complaints-dashboard-fui.component';

import { PayslipsComponent } from './payslips/payslips.component';

import { MonthlyPayrollExpenseComponent } from './monthly-payroll-expense/monthly-payroll-expense.component';

import { EmployeeProfileFuiComponent } from './employee-profile-fui/employee-profile-fui.component';

import { HrAttendanceFuiComponent } from './hr-attendance-fui/hr-attendance-fui.component';

import { HrPayrollGuideComponent } from './hr-payroll-guide/hr-payroll-guide.component';
import { EmployeeFormPrintComponent } from './employee-form-print/employee-form-print.component';
import { BillingDashboardComponent } from './billing-dashboard/billing-dashboard.component';
import { BillingCycleGraphComponent } from './billing-cycle-graph/billing-cycle-graph.component';
import { CustomerTransferReportComponent } from './customer-transfer-report/customer-transfer-report.component';
import { ViewBillInfoComponent } from './view-bill-info/view-bill-info.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { MeterChangesComponent } from './meter-changes/meter-changes.component';
import { DateChangeComponent } from './date-change/date-change.component';
import { SysadminGuard } from './auth/sysadmin.guard';
import { AssetManagementComponent } from './asset-management/asset-management.component';
import { InventoryManagementComponent } from './inventory-management/inventory-management.component';
import { AssetCategoriesComponent } from './asset-management/asset-categories/asset-categories.component';
import { DepreciationReportsComponent } from './asset-management/depreciation-reports/depreciation-reports.component';
import { StockMovementsComponent } from './inventory-management/stock-movements/stock-movements.component';
import { PurchaseOrdersComponent } from './inventory-management/purchase-orders/purchase-orders.component';
import { SuppliersComponent } from './inventory-management/suppliers/suppliers.component';
import { InventoryReportsComponent } from './inventory-management/inventory-reports/inventory-reports.component';
import { BankComponent } from './bank/bank.component';

const routes: Routes = [

  { path: '', component: LoginComponent },

  {

    path: '',

    component: LoginlayoutComponent,

    children: [{ path: 'login', component: LoginComponent }],

  },

  {

    path: '',

    component: MainlayoutComponent,

    children: [

      { path: 'dashboard', component: HomeComponent },

      { path: 'customers', component: CustomersComponent },

      { path: 'employees', component: EmployeeComponent },

      { path: 'meters', component: MeterdetailsComponent },

      { path: 'areas', component: AreadetailsComponent },

      { path: 'unitrate', component: UnitrateComponent },

      { path: 'billreports', component: BillreportsComponent },

      { path: 'expenses', component: ExpensesComponent },

      { path: 'complaint',component:ComplaintComponent},

      { path: 'control',component:AccessControlComponent},

      { path: 'wages', component:WagesComponent},

      { path: 'wagesinfo', component:WagedetailsComponent},

      { path: 'monthly-payroll-expense', component: MonthlyPayrollExpenseComponent},

      { path: 'locations', component: EmployeeLocationsComponent},

      { path: 'payroll-runs', component: PayrollRunsComponent},

      { path: 'payroll-runs/:runId', component: PayrollRunDetailsComponent},

      { path: 'hr-profiles', component: PayrollProfilesComponent },

      { path: 'fui-dashboard', component: FuiDashboardComponent },

      { path: 'payslips', component: PayslipsComponent},

      { path: 'hr-employee-profile', component: EmployeeProfileFuiComponent},

      { path: 'hr-attendance', component: HrAttendanceFuiComponent},

      { path: 'hr-payroll-guide', component: HrPayrollGuideComponent},

      { path: 'hr-employee-form', component: EmployeeFormPrintComponent},

      { path: 'complaints-dashboard', component: ComplaintsDashboardFuiComponent},

      { path: 'billing-dashboard', component: BillingDashboardComponent },

      { path: 'billing-cycle-graph', component: BillingCycleGraphComponent },

      { path: 'customer-transfer-report', component: CustomerTransferReportComponent },

      { path: 'view-bill-info', component: ViewBillInfoComponent },

      { path: 'audit-log', component: AuditLogComponent },

      { path: 'meter-changes', component: MeterChangesComponent },

      { path: 'date-change', component: DateChangeComponent, canActivate: [SysadminGuard] },

      { path: 'asset-management', component: AssetManagementComponent },

      { path: 'asset-categories', component: AssetCategoriesComponent },

      { path: 'depreciation-reports', component: DepreciationReportsComponent },

      { path: 'inventory-management', component: InventoryManagementComponent },

      { path: 'stock-movements', component: StockMovementsComponent },

      { path: 'purchase-orders', component: PurchaseOrdersComponent },

      { path: 'suppliers', component: SuppliersComponent },

      { path: 'inventory-reports', component: InventoryReportsComponent },
      { path: 'bank', component: BankComponent },

    ],

  },

];



@NgModule({

  imports: [RouterModule.forRoot(routes)],

  exports: [RouterModule],

})

export class AppRoutingModule {}

